import clsx from 'clsx';
import { Bot, User } from 'lucide-react';

/**
 * A single chat turn. Supports incremental text growth during streaming and
 * an optional "streaming" caret.
 */
export function MessageBubble({ role, content, streaming }) {
  const isUser = role === 'user';
  return (
    <div className={clsx('flex gap-3', isUser ? 'flex-row-reverse' : 'flex-row')}>
      <div className={clsx(
        'mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full',
        isUser ? 'bg-ink text-white' : 'bg-accent-soft text-accent'
      )}>
        {isUser ? <User className="h-4 w-4" strokeWidth={1.75} /> : <Bot className="h-4 w-4" strokeWidth={1.75} />}
      </div>
      <div className={clsx(
        'max-w-[80%] rounded-2xl px-4 py-2.5 text-sm',
        isUser ? 'rounded-tr-sm bg-ink text-white' : 'rounded-tl-sm border border-border bg-surface text-ink'
      )}>
        <p className="whitespace-pre-wrap break-words">
          {content}
          {streaming && <span className="ml-0.5 inline-block h-3.5 w-1.5 animate-pulse rounded-sm bg-current align-middle" />}
        </p>
      </div>
    </div>
  );
}
